import React, {Component} from 'react';

import {
  Nav,
  NavItem,
  NavLink,
  Container,
  Row,
  Col
} from 'reactstrap';

import Link from 'react-router-dom/NavLink';
import Route from 'react-router-dom/Route';
import Switch from 'react-router-dom/Switch';

import Button from '../../../shared/components/Button';


import AccountInfo from '../../AccountInfo';
import AccountBrandList from '../../AccountBrandList';
import AccountBillingList from '../../AccountBillingList';
import AccountUserList from '../../AccountUserList';
import AccountUserEdit from '../../AccountUserEdit';
import AccountSpecialPricing from '../../AccountSpecialPricing';
import AccountTransferHistory from '../../AccountTransferHistory';
import AccountNewIO from '../../AccountNewIO';
import AccountProgramList from "../../AccountProgramList";
import EditProgram from "../../EditProgram";
import {loadIOSForAgency} from "../../../shared/redux/entities/actions";

class AccountView extends Component {
  constructor(){
    super();

    this.state = {
      isLoading:false
    }
  }

  componentDidMount(){
    const {
      accountId,
      loadUsersForAgency,
      loadBrandsForAgency,
      loadKPIsForAgencyBrands,
      loadPaymentMethodsForAgency,
      loadProgramsForAgency,
      loadAgency,
      loadIOSForAgency,
      loadAccountHistory,
      loadGiftCards
    } = this.props

    const loadingPromises = [];

    this.setState({isLoading:true});

    loadingPromises.push(loadUsersForAgency(accountId));
    loadingPromises.push(loadBrandsForAgency(accountId));
    loadingPromises.push(loadKPIsForAgencyBrands(accountId));
    loadingPromises.push(loadPaymentMethodsForAgency(accountId));
    loadingPromises.push(loadAccountHistory(accountId))
    loadingPromises.push(loadProgramsForAgency(accountId))
    loadingPromises.push(loadGiftCards())
    loadingPromises.push(loadIOSForAgency(accountId))

    if(this.props.needsLoading){
      loadingPromises.push(loadAgency(accountId));
    }

    Promise.all(loadingPromises)
      .then((res) => console.log('WE GOT ALL THE STUFF',res))
      .then(() => this.setState({isLoading:false}));
    //LOAD BILLING METHODS
  }

  render(){
    const { match,name,accountId,needsLoading } = this.props;

    const {isLoading} = this.state;

    return (
      <Container>
        <Row>
          <Col xs='6'>
            <br />
            <h6>Account</h6>
            <h3>{name || 'Loading...'}</h3>
            <br />
          </Col>
          <Col xs='6' className='clearfix'>
            <br />
            <br />
            <div className='pull-right'>
              <Switch>
                <Route
                  exact path={`${match.url}/brands`}
                  render={() => (
                    <Button linkHref={`${match.url}/brands/new`}>
                      New Brand
                    </Button>
                  )}
                />
                <Route
                  exact path={`${match.url}/users`}
                  render={() => (
                    <Button linkHref={`${match.url}/users/invite`}>
                      Invite User
                    </Button>
                  )}
                />
                <Route
                  exact path={`${match.url}/paymentMethods`}
                  render={() => (
                    <Button linkHref={`${match.url}/paymentMethods/new`}>New Payment Method</Button>
                  )}
                />
                <Route
                  exact path={`${match.url}/billing`}
                  render={() => (
                    <Button linkHref={`${match.url}/billing/new`}>
                      New IO
                    </Button>
                  )}
                />
                <Route
                    exact path={`${match.url}/programs`}
                    render={() => (
                        <Button linkHref={`${match.url}/programs/new`}>
                          New Program
                        </Button>
                    )}
                />
              </Switch>
            </div>
            <br />
          </Col>
        </Row>
        <Row>
          <Col xs='12'>
            <Nav tabs className='UnderLineTabs'>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/brands`}
                  activeClassName='active'
                >
                  Brands
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/edit`}
                  activeClassName='active'
                >
                  Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink

                  tag={Link}
                  to={`${match.url}/users`}
                  activeClassName='active'
                >
                  Users
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/paymentMethods`}
                  activeClassName='active'
                >
                  Payment Methods
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/billing`}
                  activeClassName='active'
                >
                  Funds
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  tag={Link}
                  to={`${match.url}/pricing`}
                  activeClassName='active'
                >
                  Special Pricing
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                    tag={Link}
                    to={`${match.url}/programs`}
                    activeClassName='active'
                >
                  Programs
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <br />
        {!isLoading && (
          <Switch>
            <Route
              path={`${match.url}/edit`}
              render={() => (<AccountInfo accountId={accountId} />)}
            />
            <Route
              exact path={`${match.url}/users/:userId/edit`}
              render={(routeProps) => (
                <AccountUserEdit
                  accountId={accountId}
                  userId={routeProps.match.params.userId}
                />
              )}
            />
            <Route
              exact path={`${match.url}/users/invite`}
              render={() => (<AccountUserEdit accountId={accountId} isCreate />)}
            />
            <Route
              exactly path={`${match.url}/users`}
              render={() => (<AccountUserList accountId={accountId} />)}
            />
            <Route
              path={`${match.url}/brands`}
              render={() => (<AccountBrandList accountId={accountId} />)}
            />
            <Route
              path={`${match.url}/paymentMethods`}
              render={() => (<AccountBillingList accountId={accountId} />)}
            />
            <Route
              path={`${match.url}/pricing`}
              render={() => (<AccountSpecialPricing accountId={accountId} />)}
            />
            <Route
                path={`${match.url}/programs/:programId`}
                render={() => (<EditProgram accountId={accountId} />)}
            />
            <Route
                path={`${match.url}/programs`}
                render={() => (<AccountProgramList accountId={accountId} />)}
            />
            <Route
              path={`${match.url}/billing/:historyId`}
              render={() => (<AccountNewIO accountId={accountId} />)}
            />
            <Route path={`${match.url}/billing`} 
              render={() => (<AccountTransferHistory accountId={accountId} />)}
            />
          </Switch>
        )}
      </Container>
    )
  }
}

export default AccountView;



// WEBPACK FOOTER //
// ./src/routes/AccountView/components/AccountView.js